import { create } from 'zustand';

const STORAGE_KEY = 'spx_chain_settings_v1';

function normalizeInverted(value) {
  return value === true;
}

function loadSettings() {
  if (typeof localStorage === 'undefined') {
    return { fullChainInverted: false, condensedChainInverted: false };
  }

  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return {
      fullChainInverted: normalizeInverted(parsed.fullChainInverted),
      condensedChainInverted: normalizeInverted(parsed.condensedChainInverted),
    };
  } catch {
    return { fullChainInverted: false, condensedChainInverted: false };
  }
}

function saveSettings(settings) {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    // quota exceeded or storage unavailable (e.g. some private-browsing modes) -- degrade to non-persisted
  }
}

const initialSettings = loadSettings();

export const useChainSettingsStore = create((set) => ({
  fullChainInverted: initialSettings.fullChainInverted,
  condensedChainInverted: initialSettings.condensedChainInverted,
  setFullChainInverted: (value) => set((state) => {
    const next = { ...state, fullChainInverted: normalizeInverted(value) };
    saveSettings({ fullChainInverted: next.fullChainInverted, condensedChainInverted: next.condensedChainInverted });
    return next;
  }),
  setCondensedChainInverted: (value) => set((state) => {
    const next = { ...state, condensedChainInverted: normalizeInverted(value) };
    saveSettings({ fullChainInverted: next.fullChainInverted, condensedChainInverted: next.condensedChainInverted });
    return next;
  }),
  toggleFullChainInverted: () => set((state) => {
    const next = { ...state, fullChainInverted: !state.fullChainInverted };
    saveSettings({ fullChainInverted: next.fullChainInverted, condensedChainInverted: next.condensedChainInverted });
    return next;
  }),
  toggleCondensedChainInverted: () => set((state) => {
    const next = { ...state, condensedChainInverted: !state.condensedChainInverted };
    saveSettings({ fullChainInverted: next.fullChainInverted, condensedChainInverted: next.condensedChainInverted });
    return next;
  }),
}));
